<template>
  <div class="settings-card">
    <div class="card-header">
      <h3><i class="fas fa-desktop"></i> Cấu hình Hệ thống</h3>
    </div>
    
    <div class="card-body">
      <div class="settings-grid">
        <div class="form-group">
          <label>Tên cửa hàng</label>
          <input type="text" v-model="localData.storeName" @change="update" class="form-control">
        </div>
        
        <div class="form-group">
          <label>Email liên hệ</label>
          <input type="email" v-model="localData.email" @change="update" class="form-control">
        </div>

        <div class="form-group">
          <label>Số điện thoại</label>
          <input type="text" v-model="localData.phone" @change="update" class="form-control">
        </div>

        <div class="form-group full-width">
          <label>Địa chỉ</label>
          <input type="text" v-model="localData.address" @change="update" class="form-control">
        </div>

        <div class="form-group full-width d-none">
          <label>Logo URL (Link ảnh)</label>
          <div class="d-flex align-items-center">
             <input type="text" v-model="localData.logo" @change="update" class="form-control mr-2" placeholder="https://example.com/logo.png">
             <img v-if="localData.logo" :src="localData.logo" style="height: 40px; border: 1px solid #ddd; padding: 2px;">
          </div>
        </div>

        <div class="form-group">
          <label>Ngôn ngữ</label>
          <select v-model="localData.language" @change="update" class="form-control">
            <option value="vi">Tiếng Việt</option>
            <option value="en">English</option>
          </select>
        </div>

        <div class="form-group">
          <label>Múi giờ</label>
          <select v-model="localData.timezone" @change="update" class="form-control">
            <option value="Asia/Ho_Chi_Minh">Vietnam (GMT+7)</option>
            <option value="UTC">UTC</option>
          </select>
        </div>

        <div class="form-group">
          <label>Tiền tệ</label>
          <select v-model="localData.currency" @change="update" class="form-control">
            <option value="VND">VND (₫)</option>
            <option value="USD">USD ($)</option>
          </select>
        </div>

        <div class="form-group">
          <label>Định dạng ngày</label>
          <select v-model="localData.dateFormat" @change="update" class="form-control">
            <option value="DD/MM/YYYY HH:mm">DD/MM/YYYY HH:mm</option>
            <option value="YYYY-MM-DD HH:mm">YYYY-MM-DD HH:mm</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  data() {
    return {
      localData: JSON.parse(JSON.stringify(this.data))
    }
  },
  watch: {
    data: {
      handler(val) {
        this.localData = JSON.parse(JSON.stringify(val));
      },
      deep: true
    }
  },
  methods: {
    update() {
      this.$emit('update', 'system', this.localData);
    }
  }
}
</script>



